import React from 'react';
import { IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { useHistory } from 'react-router';

export type LinkCellProps = {
  row: { date: string };
};

const useRenderLinkCellStyles = makeStyles()(theme => ({
  root: {
    fontSize: '14px',
    color: theme.palette.text.secondary
  }
}));

export const LinkCell: React.FC<LinkCellProps> = ({ row }) => {
  const { classes } = useRenderLinkCellStyles();
  const history = useHistory();

  return (
    <IconButton onClick={() => history.push(`/finance/${row.date}/all`)}>
      <ArrowForwardIosIcon classes={classes} />
    </IconButton>
  );
};
